import { useMemo } from 'react';
import { Unit, Lease, ActionItem } from '@urbanmix-tech/shared-js';
import { PricingWizardContextValue } from '../types';
import { PricingSingleMode } from './PricingSingleMode';
import { PricingBatchMode } from './PricingBatchMode';

interface PricingStepProps {
  units: Unit[];
  leases: Lease[];
  allLeases: Lease[];
  actionItems: ActionItem[];
  wizard: PricingWizardContextValue;
}

export function PricingStep({
  units,
  leases,
  allLeases,
  actionItems,
  wizard,
}: PricingStepProps) {
  const { state } = wizard;
  const { pricingMode } = state;

  // Create lease map for quick lookup
  const leaseMap = useMemo(() => {
    const map = new Map<string, Lease>();
    leases.forEach((lease) => {
      const existing = map.get(lease.unitId);
      if (!existing || new Date(lease.leaseStartDate) > new Date(existing.leaseStartDate)) {
        map.set(lease.unitId, lease);
      }
    });
    return map;
  }, [leases]);

  return (
    <div className="pricing-step h-full flex flex-col min-h-0">
      {/* Content based on mode */}
      <div className="flex-1 min-h-0 overflow-hidden">
        {pricingMode === 'single' ? (
          <PricingSingleMode
            units={units}
            selectedUnits={wizard.selectedUnits}
            leases={leases}
            allLeases={allLeases}
            leaseMap={leaseMap}
            wizard={wizard}
          />
        ) : (
          <PricingBatchMode
            units={units}
            selectedUnits={wizard.selectedUnits}
            leases={leases}
            allLeases={allLeases}
            leaseMap={leaseMap}
            wizard={wizard}
          />
        )}
      </div>
    </div>
  );
}
